(() => {
	document.querySelectorAll(".block-pricing-calculator").forEach((block) => {
		const input = block.querySelector("[data-qty-input]");
		const priceWrap = block.querySelector(".estimated-price");
		const minusBtn = block.querySelector("[data-qty-minus]");
		const plusBtn = block.querySelector("[data-qty-plus]");

		if (!input || !priceWrap) return;

		const priceSpan = priceWrap.querySelector("span");
		const priceItems = priceWrap.querySelectorAll("[data-price-item]");
		const maxQty = parseInt(input.dataset.maxQty, 10) || null;

		const basePrice = parseFloat(priceWrap.dataset.basePrice) || 0;
		const baseAltPrice = parseFloat(priceWrap.dataset.basePriceAlt) || 0;

		// Number formatter (1234 -> 1,234)
		const formatNumber = (n) =>
			new Intl.NumberFormat("en-US").format(Number(n) || 0);
		

		const clamp = (n) => {
			let val = Math.max(1, n || 1);
			if (maxQty) val = Math.min(maxQty, val);
			return val;
		};

		const updateButtonState = (qty) => {
			if (minusBtn) {
				const disabled = qty === 1;
				minusBtn.style.opacity = disabled ? "0.5" : "1";
				minusBtn.style.cursor = disabled ? "default" : "pointer";
			}

			if (plusBtn && maxQty) {
				const disabled = qty === maxQty;
				plusBtn.style.opacity = disabled ? "0.5" : "1";
				plusBtn.style.cursor = disabled ? "default" : "pointer";
			}
		};

		const updatePrice = (qty) => {
			if (priceItems.length) {
				priceItems.forEach((item) => {
					const base = parseFloat(item.dataset.basePrice) || 0;
					const span = item.querySelector("span");
					if (span) span.textContent = `$${formatNumber(base * qty)}`;
				});
			} else {
				const min = basePrice * qty;
				const max = baseAltPrice * qty;
				if (priceSpan) priceSpan.textContent = `$${formatNumber(min)} - $${formatNumber(max)}`;
			}

			updateButtonState(qty);
		};

		const getValue = () => clamp(parseInt(input.value, 10));
		const setValue = (n) => {
			const qty = clamp(n);
			input.value = String(qty);
			updatePrice(qty);
		};

		minusBtn?.addEventListener("click", (e) => {
			e.preventDefault();
			setValue(getValue() - 1);
		});

		plusBtn?.addEventListener("click", (e) => {
			e.preventDefault();
			setValue(getValue() + 1);
		});

		["input", "change", "blur"].forEach((evt) =>
			input.addEventListener(evt, () => setValue(getValue()))
		);

		updatePrice(getValue());
	});
})();
